<template>
  <div id="app">
      <Template v-if='this.$route.name !== "login"'/>
      <router-view v-else />
      <notifications group="succes" position="top right" />
      <notifications group="error" position="top right"  />
      <notifications group="warning" position="top right"  />
  </div>
</template>
<script>

import Template from './template/Template'
import { loadLanguageAsync } from './plugins/i18n'
import Pusher from 'pusher-js'
import axios from 'axios'
export default {
  name: 'app',
  components: {
    Template
  },
  created () {
    // Pusher.logToConsole = true
    let pusher = new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
      cluster: 'eu',
      forceTLS: true
    })
    let channel = pusher.subscribe('public')
    let vm = this
    channel.bind('change-role-permissions', function (data) {
      if (vm.$store.getters.user.roles.includes(data.roleName)) {
        vm.$store.dispatch('userRequest')
      }
    })
    channel.bind('test', function (data) {
      alert(data.msg)
    })
    let language = window.localStorage.getItem('language') || 'ro'
    loadLanguageAsync(language)
    axios.interceptors.response.use(undefined, function (err) {
      return new Promise(function (resolve, reject) {
        let error = err.response || null
        if (error && error.status === 401 && error.config && !error.config.__isRetryRequest) {
          vm.$store.dispatch('logoutRequest').then((response) => {
            vm.$router.push({ name: 'login' })
          })
        }
        // if (error && error.status === 403 && error.config && !error.config.__isRetryRequest) {
        //   vm.$router.push('/')
        // }
        throw err
      })
    })
  }
}
</script>
<style lang="scss">
  @import "assets/css/app";
</style>
